import React, { useState, useEffect } from 'react';
import { Container, Stack } from '@mui/material';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import { SystemUserForm } from '../../../../components/forms/system-user-form';
import { TeamService } from '../../../../services/team.service';
import { GroupService } from '../../../../services/groups.service';

export const CreateSystemUserScreen: React.FC = () => {
    useEffect(() => {
        // Load teams and groups for the form dropdowns
        TeamService.fetchAll();
        GroupService.fetchAll();
    }, []);

    return (
        <Page title="POM Safe - Invite System Users">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Invite System Users"
                        links={[
                            {
                                name: 'List',
                                href: '/system-users'
                            },
                            {
                                name: 'Create',
                                href: '/system-users/create'
                            },
                        ]}
                        activeLast={false}
                    />
                </Stack>

                <SystemUserForm />
            </Container>
        </Page>
    )
}